<template lang="pug">
  DefaultLayout(v-if="user")
    CommonSection(title="Партнерская программа")
      .b-affiliate-main-page
        ._tabs
          AffiliateTabs
        FormBlock(mobile)._main
          ._block.-balance
            ._title Ваш баланс
            ._balance
              ._balance-item
                ._balance-value {{ balance }} ₽
                ._balance-sign Доступно
              ._vline
              ._balance-item
                ._balance-value {{ fullIncome }} ₽
                ._balance-sign За все время
              div
          ._block.-link
            ._title.-underline Партнёрская ссылка:
            ._link(@click="copyUrl(referralLink)") {{ referralLink }}
          ._block.-count
            ._title Кол-во рефералов
              Icon(name="referrals-total")
            ._count {{ referrals.length }}
              ._count-note +{{ Math.round(referralsIncome * 100) }}% за месяц
          ._block.-count
            ._title Активные рефералы
              Icon(name="referrals-active")
            ._count {{ activeReferrals.length }}
              ._count-note +{{ Math.round(activeReferralsIncome * 100) }}% за месяц
          ._block.-link
            ._title.-underline Ссылка регистрации в Teroom:
            ._link(@click="copyUrl(registerLink)") {{ registerLink }}
        FormBlock(mobile)._aside Отправьте партнёрскую ссылку знакомому или коллеге. Если он зарегистрируется в системе, то вы увидите его в списке своих рефералов. От каждого платежа реферала вы будете получать 30% на партнёрский счёт.
          ._aside-hint Также новый пользователь получит 750 руб. на свой счёт, что эквивалентно 1 месяцу на тарифе Мини.  Другими словами – 30 дней тарифа Мини он получит бесплатно.
        FormBlock(mobile)
          ChartBar(v-bind="paymentsStats")
</template>

<script>
import affiliateModel from '@/model/affiliate';

import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import FormBlock from '@/components/FormBlock.vue';
import AffiliateTabs from '@/components/affiliate/AffiliateTabs.vue';
import ChartBar from '@/components/chart/ChartBar.vue';

export default {
  name: 'PersonalAffiliateReferralsPage',
  components: {
    ChartBar,
    AffiliateTabs,
    FormBlock,
    DefaultLayout,
    CommonSection,
  },
  computed: {
    user() { return this.$store.state.auth?.user; },
    balance() { return this.user.affiliateBalance / 100; },
    referrals() { return this.$store.getters['affiliate/referrals']; },
    paymentsSum() { return this.referrals.reduce((acc, val) => acc + val.paymentsSum, 0); },
    fullIncome() { return Math.floor(this.paymentsSum * 0.3) / 100; },
    activeReferrals() { return this.referrals.filter(r => r.status === 'active'); },
    referralsAtThisMonth() { return this.referrals.filter(r => r.createdAt > this.firstDayOfMonth); },
    activeReferralsAtThisMonth() { return this.referralsAtThisMonth.filter(r => r.status === 'active'); },
    referralLink() { return `${document.location.origin}/afl/${this.$store.state.auth.user.ownReferralCode}`; },
    registerLink() { return `${document.location.origin}/register/${this.$store.state.auth.user.ownReferralCode}`; },
    referralsIncome() { return this.referrals.length > 0 ? this.referralsAtThisMonth.length / this.referrals.length : 0; },
    activeReferralsIncome() { return this.activeReferrals.length > 0 ? this.activeReferralsAtThisMonth.length / this.activeReferrals.length : 0; },
    firstDayOfMonth() {
      const d = new Date();
      return new Date(d.getFullYear(), d.getMonth(), 1);
    },
    paymentsStats() { return affiliateModel.buildStats(this.$store.getters['affiliate/transactions'] ?? []); },
  },
  created() {
    this.$store.dispatch('affiliate/fetch');
  },
  methods: {
    copyUrl(url) {
      navigator.clipboard.writeText(url);
      this.$push({ text: 'Ссылка скопирована в буфер обмена' });
    },
  },
};
</script>

<style scoped lang="scss">
  .affiliate-main-page {
    display: grid;
    grid-template-columns: 1fr 312px;
    gap: 35px;
    align-items: start;

    &__main {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 26px;
    }

    &__block {
      padding: 16px;
      background: #F8F9FC;
      border-radius: 10px;
      &--link {
        grid-column: 3 / 2 span;
      }
      &--balance {
        grid-column: 1 / 2 span;
      }
      &--count {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 20px;
      }
    }

    &__count {
      font-size: 32px;
      line-height: 30px;
      letter-spacing: 0.01em;
      color: #1E3147;
      display: flex;
      align-items: flex-end;
      gap: 10px;

      &-note {
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: 0.01em;
        color: #92A0B0;
      }
    }

    &__title {
      font-weight: 500;
      font-size: 12px;
      line-height: 24px;
      color: #1E3147;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &--underline {
        border-bottom: 1px solid #EBEFF2;
      }
    }

    &__vline {
      width: 1px;
      background: #EBEFF2;

      &:before {
        display: block;
        content: '';
        width: 1px;
        background: #EBEFF2;
        height: 100%;
        position: relative;
        top: -24px;
      }
    }

    &__balance {
      display: flex;
      justify-content: space-between;

      &-value {
        font-weight: 700;
        font-size: 30px;
        line-height: 38px;
        letter-spacing: 0.01em;
        color: #33A1FB;
      }

      &-sign {
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: 0.01em;
        color: #92A0B0;
      }
    }

    &__link {
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      color: #33A1FB;
      display: flex;
      align-items: center;
      gap: 5px;
      margin-top: 16px;
      cursor: pointer;

      &:before {
        display: block;
        content: '';
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background: #33A1FB;
        background: url('../assets/img/svg/copy.svg') center no-repeat var(--color-accent);
      }
    }

    &__tabs {
      grid-column: 1 / 2 span;
    }

    &__aside {
      padding: 25px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #1E3147;
      grid-row: 2 / 2 span;
      grid-column: 2;

      &-hint {
        margin-top: 20px;
        background: #FFE0CC;
        border-radius: 8px;
        padding: 15px;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        color: #1E3147;
      }
    }

    @media (max-width: 1600px) {
      grid-template-columns: 1fr;

      &__tabs {
        grid-column: 1 / 1 span;
      }

      &__aside {
        grid-column: 1;
        grid-row: 3;
      }
    }
    @media (max-width: 1400px) {
      &__main {
        grid-template-columns: repeat(2, 1fr);
      }

      &__block {
        &--link {
          grid-column: 1 / 2 span;
        }
        &--balance {
          grid-column: 1 / 2 span;
        }
        &--count {
          grid-row: 2;
        }
      }
    }
    @media (max-width: 768px) {
      &__main {
        grid-template-columns: 1fr;
      }

      &__tabs {
        overflow-x: scroll;
      }

      &__balance {
        flex-direction: column;
      }

      &__vline {
        height: 1px;
        width: 100%;
        margin: 21px 0 30px;
      }

      &__link {
        overflow-wrap: break-word;
        width: 100%;
        box-sizing: border-box;
      }

      &__block {
        &--link {
          grid-column: 1 / 1 span;
          overflow-wrap: break-word;
          box-sizing: border-box;
          width: 100%;

          &:nth-child(2) {
            grid-row: 4;
          }
        }
        &--balance {
          grid-column: 1 / 1 span;
        }
        &--count {
          grid-row: auto;
        }
      }
    }
  }
</style>
